export const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
export const ownerNamePattern = /(^|[ \-'./& ,])([a-z])/g;
